import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import type { BonusPointType } from '@packages/gql/generated/shopping/graphql';
import { Stack, Typography } from '@packages/shared';
import { Joe, PaybackColored32 } from '@packages/themes/icons';
import { defineMessages, useIntl } from 'react-intl';

const BonusPointsFragment = graphql(/* GraphQL */ `
  fragment BonusPointsFragment on Bonuspoints {
    points
    type
  }
`);

export const bonusPointsPaybackMessages = defineMessages<BonusPointType>({
  PAYBACK: {
    id: 'bonusPoints.payback.text',
    defaultMessage: '{points} PAYBACK {points, plural, one {Punkt} other {Punkte}}',
  },
  JOE: {
    id: 'bonusPoints.joe.text',
    defaultMessage: '{points} {points, plural, one {Ö} other {Ös}} sammeln',
  },
});

type BonusPointsProps = {
  bonusPointsData: FragmentType<typeof BonusPointsFragment>;
};

/**
 * This component is used to render either Joe or Payback bonus points.
 */
export const BonusPoints = ({ bonusPointsData }: BonusPointsProps) => {
  const { points, type } = getFragmentData(BonusPointsFragment, bonusPointsData);
  const { formatMessage } = useIntl();

  const Icon = type === 'PAYBACK' ? PaybackColored32 : Joe;

  return (
    <Stack spacing={0.5} direction="row" alignItems="center">
      <Icon sx={{ fontSize: '1rem' }} />
      <Typography component="span" variant="body1" sx={{ fontWeight: 'fontWeightSemiBold' }}>
        {formatMessage(bonusPointsPaybackMessages[type], {
          points,
        })}
      </Typography>
    </Stack>
  );
};
